import React from 'react'

import { AddButton } from '../../../components/scharedStyles/style'
import { ToolbarWrap } from '../style'
import { useEditScheduleEditorOperations } from '../hooks'

const EditScheduleToolbar = () => {
    const { openAddEditor } = useEditScheduleEditorOperations()

    return (
        <ToolbarWrap>
            <AddButton onClick={() => openAddEditor()} type="button">
                + Добавить
            </AddButton>
        </ToolbarWrap>
    )
}

export default EditScheduleToolbar
